/**
 * Best-effort extraction of an HTTP status code from a thrown fetch/client error.
 * Covers the shapes used by ofetch (statusCode / status / response.status) and
 * typesense-js (httpStatus). Returns undefined for network/timeout errors that
 * carry no status.
 */
export function getErrorStatus(error: unknown): number | undefined {
  const e = error as { statusCode?: number, status?: number, httpStatus?: number, response?: { status?: number } }
  const status = e?.statusCode ?? e?.status ?? e?.response?.status ?? e?.httpStatus
  return typeof status === "number" ? status : undefined
}
